(() => {
  'use strict';
  if (window.AWCompatibilityP1Loader?.version) return;
  const VERSION = '1.23.1-cwv-20261002';
  const current = document.currentScript?.src || '';
  const sibling = (filename) => {
    try {
      const url = new URL(filename, current || location.href);
      url.searchParams.set('aw_p1', VERSION.replace(/\D/g, ''));
      return url.href;
    } catch (_) { return filename; }
  };
  const load = (filename, key) => new Promise((resolve, reject) => {
    if (document.querySelector(`script[data-aw-compat-loader="${key}"]`)) { resolve(); return; }
    const script = document.createElement('script');
    script.src = sibling(filename);
    script.defer = true;
    script.dataset.awCompatLoader = key;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
  load('aw-compatibility-live-directory-core.js', 'core')
    .then(() => load('aw-compatibility-ux-p1.js', 'ux'))
    .then(() => load('aw-compatibility-ux-context-p1.js', 'ux-context'))
    .then(() => load('aw-compatibility-ux-proof-p1.js', 'ux-proof'))
    .then(() => load('aw-compatibility-ux-modelpage-p1.js', 'ux-modelpage'))
    .then(() => load('aw-compatibility-ux-states-mobile-p1.js', 'ux-states-mobile'))
    .then(() => load('aw-compatibility-ux-directory-catalog-p1-cwv-20261002-v3.js', 'ux-directory-catalog'))
    .then(() => load('aw-compatibility-ux-accessibility-p1.js', 'ux-accessibility'))
    .then(() => load('aw-compatibility-ux-copy-cleanup-p1.js', 'ux-copy-cleanup'))
    .then(() => load('aw-compatibility-ux-deeplink-p1.js', 'ux-deeplink'))
    .then(() => load('aw-compatibility-ux-finalize-p1-cwv-20261002-v2.js', 'ux-finalize'))
    .then(() => load('aw-compatibility-ux-context-copy-guard-p1.js', 'ux-context-copy-guard'))
    .then(() => load('aw-compatibility-ux-relation-copy-guard-p1.js', 'ux-relation-copy-guard'))
    .catch(() => {});
  window.AWCompatibilityP1Loader = { version: VERSION };
})();

